import React from "react";

export default function ChevronToggleButton({
  isExpanded,
  onClick,
  controlsId,
  expandedLabel = "Collapse section",
  collapsedLabel = "Expand section",
  expandedTitle,
  collapsedTitle,
  className = "",
  disabled = false,
  type = "button",
}) {
  const ariaLabel = isExpanded ? expandedLabel : collapsedLabel;
  const title = isExpanded
    ? expandedTitle || expandedLabel
    : collapsedTitle || collapsedLabel;
  const classes = ["shared-section-toggle-btn", className]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      aria-expanded={isExpanded}
      aria-controls={controlsId}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      {isExpanded ? "▴" : "▾"}
    </button>
  );
}
